/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-aceite[_ngcontent-%COMP%]{color:red;text-align:justify}.alert-separator[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:10px}.field-aceite[_ngcontent-%COMP%]{text-align:left}.termos-uso-modal-body[_ngcontent-%COMP%]{overflow-y:scroll;max-height:calc(100vh - 300px)}"];
export { styles as styles };
